import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated, logout } from '../services/authService';

/**
 * Hook zum automatischen Logout bei abgelaufener Session
 * Prüft alle 5 Minuten ob die Session noch gültig ist
 */
export function useSessionCheck() {
  const navigate = useNavigate();

  useEffect(() => {
    // Sofort beim Mount prüfen
    checkSession();

    // Alle 5 Minuten prüfen
    const interval = setInterval(checkSession, 5 * 60 * 1000);

    // Cleanup
    return () => clearInterval(interval);
  }, []);

  const checkSession = async () => {
    const authenticated = await isAuthenticated();
    
    if (!authenticated) {
      console.log('Session abgelaufen - automatischer Logout');
      await logout();
      navigate('/login', { 
        replace: true,
        state: { message: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.' }
      });
    }
  };
}
